import { api } from '@/common/api';
import qs from 'qs';

const store = {
    namespaced: true,
    state() {
        return {
            dealsTotalSum: {},
            totalCalculateSum: {},
            expensesDeals: {},
            isIssetDealFine: 0
        };
    },

    mutations: {
        setDealsTotalSum(state, value) {
            state.dealsTotalSum = value;
        },
        setTotalCalculateSum(state, value) {
            state.totalCalculateSum = value;
        },
        setExpensesDeals(state, value) {
            state.expensesDeals = value;
        },
        setIsIssetDealFine(state, value) {
            state.isIssetDealFine = value;
        },
        clearStore(state) {
            state.dealsTotalSum = {};
            state.totalCalculateSum = {};
            state.expensesDeals = {};
        }
    },
    actions: {
        seIsIssetDealFine({ state, commit }, value) {
            commit('setIsIssetDealFine', value);
        },
        setDealsTotalSum({ state, commit }, value) {
            commit('setDealsTotalSum', value.totalSum);
        },
        setTotalCalculateSum({ state, commit }, value) {
            commit('setTotalCalculateSum', value.totalSum);
        },
        setExpensesDeals({ state, commit }, value) {
            commit('setExpensesDeals', value);
        },
        async getPayrolls({ state, commit }, params) {
            try {
                const response = await api.get(`/employer-payroll/?${qs.stringify(params)}`);
                return response.data;
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async updatePayroll({ state, commit }, payroll) {
            try {
                const response = await api.put('/employer-payroll/' + payroll.id, { ...payroll });
                return { ...response.data.data };
            } catch (e) {
                let errors = [];
                if (e.response && e.response.status === 422) {
                    errors = e.response.data.errors;
                }
                throw new Error(JSON.stringify(errors));
            }
        },
        async createPayroll({ state, commit }, payroll) {
            try {
                const response = await api.post('/employer-payroll/', { ...payroll });
                return { ...response.data.data };
            } catch (e) {
                let errors = [];
                if (e.response && e.response.status === 422) {
                    errors = e.response.data.errors;
                }
                throw new Error(JSON.stringify(errors));
            }
        },
        async deletePayroll({ state, commit }, payrollId) {
            try {
                await api.delete(`/employer-payroll/${payrollId}`);
            } catch (e) {
                throw new Error(JSON.stringify(e));
            }
        },
        async getDateList({ state, commit }, params) {
            try {
                const response = await api.get('/employer-payroll-info/get-date-list');
                return { ...response.data.data };
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async getEmployersToPositions({ state, commit }, params) {
            try {
                const response = await api.post('/employer-payroll-info/get-employers-to-positions', { ...params });
                return { ...response.data.data };
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async getEmployerDealPayrollInfo({ state, commit }, params) {
            try {
                const response = await api.post('/employer-payroll-info/calculate-employer-deals', { ...params });
                return { ...response.data.data };
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async calculateTotal({ state, commit }, params) {
            try {
                const response = await api.post('/employer-payroll-info/calculate-total', { ...params });
                return { ...response.data.data };
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async getSummaryStatisticsEmployer({ state, commit }, params) {
            try {
                const response = await api.post('/employer-payroll-info/get-summary-statistics-employer', { ...params });
                return { ...response.data.data };
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async getExistedReportDatesInfo() {
            try {
                const response = await api.get('/employer-payroll/existed-report-dates/');
                return { ...response.data.data };
            } catch (e) {
                throw new Error(JSON.stringify(e));
            }
        },
        async clonePayrolls({ state, commit }, params) {
            try {
                const response = await api.post('/employer-payroll/clone', { ...params });
                return { ...response.data.data };
            } catch (e) {
                let errors = [];
                if (e.response && e.response.status === 422) {
                    errors = e.response.data.errors;
                }
                throw new Error(JSON.stringify(errors));
            }
        },
        async getPrepayments({ state, commit }, params) {
            try {
                const response = await api.get(`/employer-prepayment/?${qs.stringify(params)}`);
                return response.data;
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async updatePrepayment({ state, commit }, prepayment) {
            try {
                const response = await api.put('/employer-prepayment/' + prepayment.id, { ...prepayment });
                return { ...response.data.data };
            } catch (e) {
                let errors = [];
                if (e.response && e.response.status === 422) {
                    errors = e.response.data.errors;
                }
                throw new Error(JSON.stringify(errors));
            }
        },
        async createPrepayment({ state, commit }, prepayment) {
            try {
                const response = await api.post('/employer-prepayment/', { ...prepayment });
                return { ...response.data.data };
            } catch (e) {
                let errors = [];
                if (e.response && e.response.status === 422) {
                    errors = e.response.data.errors;
                }
                throw new Error(JSON.stringify(errors));
            }
        }
    }
};

export default store;
